import React from "react"
import { ShimmerThumbnail } from "react-shimmer-effects"

function FMCTransactionsShimmer() {
  const shimmerGrids = Array.from({ length: 4 }, (_, index) => {
    return <ShimmerThumbnail height={30} rounded />
  })
  return (
    <div className="vehicle-shimmer-parent">
      <ShimmerThumbnail rounded height={80} />
      {shimmerGrids}
    </div>
  )
}

export default FMCTransactionsShimmer
